import React, { useEffect, useRef } from 'react';

interface SheetWrapperProps {
  onClickOutside: (target: EventTarget | null) => void;
  children: React.ReactNode;
  excludeSelector?: string;
}

// to allow close the sheet on click outside
const SheetWrapper: React.FC<SheetWrapperProps> = ({
  onClickOutside,
  children,
  excludeSelector,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target || !ref.current || ref.current.contains(target)) return;

      if (excludeSelector) {
        const excludedElements = document.querySelectorAll(excludeSelector);
        const excludedArray = Array.from(excludedElements);
        for (const excludedElement of excludedArray) {
          if (excludedElement.contains(target)) return;
        }
      }

      onClickOutside(target);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClickOutside, excludeSelector]);

  return (
    <div id="sheetWrapper" ref={ref}>
      {children}
    </div>
  );
};

export default SheetWrapper;
